import { getOmrLocaleFromCookie } from '@ramp106/omrjs-platform'

import { LocaleEnum } from '@/gql/myomr'

export const availableLocales = [LocaleEnum.En, LocaleEnum.De]
export const defaultLocale = availableLocales[0]

// Taken from: https://fettblog.eu/typescript-array-includes/
function includes<T extends U, U>(coll: ReadonlyArray<T>, el: U): el is T {
  return coll.includes(el as T)
}

export const getValidLocale = (locale: string | null | undefined, withDefault: boolean): LocaleEnum | undefined => {
  return includes(availableLocales, locale) ? locale : withDefault ? defaultLocale : undefined
}

export const getBrowserLocale = (): LocaleEnum => {
  if (navigator) {
    const locale = navigator.language.split('-')[0]
    return getValidLocale(locale, true)!
  } else {
    return defaultLocale
  }
}

export const getInitialLocale = (): LocaleEnum => {
  const cookieLocale = getOmrLocaleFromCookie()
  return getValidLocale(cookieLocale, false) ?? getBrowserLocale()
}
